import { JellyfinItem } from "../api/jellyfin";

export const MINIMUM_RESUME_TICKS = 600_000_000;

export function hasMeaningfulResume(item: JellyfinItem) {
  return (item.UserData?.PlaybackPositionTicks ?? 0) >= MINIMUM_RESUME_TICKS;
}
